import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type SetTextAction = PayloadAction<string>;

// Define a type for the slice state
export type CodeSearchState = {
  text: string;
};

// Define the initial state using that type
const initialState: CodeSearchState = {
  text: '',
};

export const codeSearchSlice = createSlice({
  name: 'codeSearch',

  initialState,

  reducers: {
    setText(state, action: SetTextAction) {
      state.text = action.payload;
    },

    reset(state: CodeSearchState) {
      return { ...initialState };
    },
  },
});

export const { setText, reset } = codeSearchSlice.actions;

export default codeSearchSlice.reducer;
